import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "popular-game" };
const _hoisted_2 = { class: "overlay pt-32 pb-120" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "row wow fadeInUp" };
const _hoisted_5 = { class: "col-12" };
const _hoisted_6 = { class: "single-box" };
const _hoisted_7 = { href: "casino/all" };
const _hoisted_8 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "abs-item" }, [
                _createElementVNode("img", {
                    src: "/assets/images/popular-game-item.png",
                    alt: "icon"
                })
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("a", _hoisted_7, [
                                    _createElementVNode("img", {
                                        src: `${$data.Const.URL}/frontend/Default/img/providers/allproviders.png`,
                                        alt: "all providers"
                                    }, null, 8, _hoisted_8)
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
